PopOver = require 'views/lib/pop-over'
View = require 'view'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')('custom_fields')
trackUe = require 'debug/trackUe'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

template = t.renderable ({ name }) ->
  t.div ->
    t.p ->
      t.format 'delete warning'
    t.p ->
      t.format 'delete prompt', { fieldName: name }
    t.input '.js-field-name',
      name: 'name'
      type: 'text'
      autofocus: true
      spellcheck: true
      placeholder: t.l('field name')
    t.div ->
      t.button '.full.negate.js-delete-field.disabled', { disabled: true }, ->
        t.format 'delete field'

module.exports = class CustomFieldDeleteView extends View
  viewTitleKey: 'delete field'

  initialize: ->
    @customField = @options.customField

  events:
    'click .js-delete-field': 'removeField'
    'input .js-field-name': 'validateName'

  render: ->
    @$el.html template({ name: @customField.get('name') })

    @

  validateName: (e) ->
    $el = @$(e.target)
    newName = $el.val()
    allowDelete = newName == @customField.get('name')
    @$('.js-delete-field').toggleClass('disabled', !allowDelete).prop('disabled', !allowDelete)

  removeField: (e) ->
    Util.stop(e)
    @customField.destroy()
    trackUe 'card-detail',
      'deletes',
      'custom field definition',
      @customField.get('type'),
      '',
      'by clicking the delete button',
      CUSTOM_FIELDS_ID
    PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-delete-view.coffee